export const helpers = {
  'value of': (formula: string) => '<xsl:value-of select="' + formula + '"/>',
  if: () => '<xsl:if test="test"></xsl:if>',
  choose: () =>
    `<xsl:choose><xsl:when test="test">chosen</xsl:when><xsl:otherwise>otherwise</xsl:otherwise></xsl:choose>`,
  space: () => '<xsl:text>&#x20;</xsl:text>',
  'line break': () => '<xsl:text>&#xa;</xsl:text>',
  text: (formula: string) => `<xsl:text>${formula}</xsl:text>`,
  'format number': (formula: string) =>
    `<xsl:value-of select="format-number(${formula},'#.###')"/><xsl:text>,-</xsl:text>`
};
